/**
 * DemoRoleSwitcher
 * ──────────────────────────────────────────────────────────────────────
 * Demo-only compact dropdown used to showcase the 4 role-specific
 * scheduler views (Front Desk / MA / Provider / Manager).
 *
 * DO NOT render this in real mode — the caller must gate on `isDemo`.
 * In real mode, the role is derived from the authenticated user's
 * app_role via `resolveSchedulerRole()`.
 */
import { Sparkles } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { SCHEDULER_ROLES } from '../../../../lib/schedulerRole';

const DemoRoleSwitcher = ({ value, onChange, className }) => (
  <div
    className={cn(
      'flex items-center gap-1.5 rounded-lg border border-violet-200 bg-violet-50/60 px-2 py-1',
      className
    )}
    data-testid="demo-role-switcher"
  >
    <Sparkles className="h-3 w-3 text-violet-500 shrink-0" />
    <span className="text-[9px] uppercase tracking-wide text-violet-700 font-semibold shrink-0">
      Demo role
    </span>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-transparent text-[11px] font-medium text-slate-800 outline-none cursor-pointer"
      style={{ border: 'none' }}
      data-testid="demo-role-switcher-select"
    >
      {SCHEDULER_ROLES.map((r) => (
        <option key={r.id} value={r.id}>
          {r.label}
        </option>
      ))}
    </select>
  </div>
);

export default DemoRoleSwitcher;
